import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';
import { footerHeightPx, tabletBreakpoint } from 'core/layouts/ui-blocks/ReusableStyles';

export const footerStyles = {
	// footer
	footerWrapper: {
		flexShrink: 0,

		width: '100%',
		height: { xs: 'fit-content', [tabletBreakpoint]: footerHeightPx },
		minHeight: footerHeightPx,
		padding: { xs: '8px 0', [tabletBreakpoint]: 0 },
		borderWidth: '1px 0 0 0',
		borderStyle: 'solid',
		borderColor: 'colors.dark3',

		backgroundColor: 'colors.dark5',
		display: 'flex',
		justifyContent: 'center',
		zIndex: 104,
	},
	footer: {
		width: '100%',
		padding: { xs: '8px 16px', [tabletBreakpoint]: '0 40px' },

		display: 'flex',
		flexDirection: { xs: 'column', [tabletBreakpoint]: 'row' },
		justifyContent: 'space-between',
		alignItems: { xs: 'flex-start', sm: 'center' },

		gap: { xs: '8px', [tabletBreakpoint]: '16px' },
	},
	backedByYComb: {
		'& img': { height: '16px', width: 'auto' },
	},

	logos: {
		gap: '10px',
		'& svg': { height: '12px', width: 'auto' },
		'& img': { height: '12px', width: 'auto' },
	},
	links: {
		flexDirection: { xs: 'column', sm: 'row' },
		justifyContent: 'center',
		gap: { xs: '8px', [tabletBreakpoint]: '10px' },
		alignItems: { xs: 'flex-start', sm: 'center' },
		flexWrap: 'wrap',
		width: { xs: '100%', sm: 'auto' },
	},
	aboutUs: {
		flexDirection: { xs: 'column', sm: 'row' },
		alignItems: 'flex-start',
		gap: { xs: '8px', sm: '12px' },
	},
	divider: {
		height: '14px',
		borderRight: `1px solid ${colorPalette.light5}`,
	},

	footerTextButton: {
		padding: 0,
		minWidth: 'unset',

		display: 'flex',
		alignItems: 'center',
		gap: '4px',

		textDecoration: 'none',
		textTransform: 'none',

		'& svg': { height: '16px', width: 'auto' },
	},

	footerText: {
		color: 'colors.light5',

		'> ul': {
			paddingInlineStart: { xs: 0, [tabletBreakpoint]: '40px' },
			marginBlockStart: 0,
			marginBlockEnd: 0,

			'> li': {
				listStyleType: { xs: 'none', [tabletBreakpoint]: 'disc' },
			},
		},
	},
};
